import { TextHilight } from './file-pages-viewer';

export const PENDING_TEXT_HILIGHT_EVENT = 'concourse:pending-text-hilight';

let pending: TextHilight | null = null;

export function setPendingTextHilight(selection: TextHilight) {
  pending = selection;
  window.dispatchEvent(new CustomEvent(PENDING_TEXT_HILIGHT_EVENT));
}

/** Returns and clears the pending selection. Optionally require a matching fileId. */
export function getPendingTextHilight(fileId?: string): TextHilight | null {
  if (!pending) return null;
  if (fileId && pending.fileId !== fileId) return null;
  const value = pending;
  pending = null;
  return value;
}
